import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'barrierName'
})
export class BarrierNamePipe implements PipeTransform {
    types = {
        'dam': 'Dam',
        'weir': 'Weir',
        'culvert': 'Culvert',
        'ford': 'Ford',
        'sluice_gate': 'Sluice',
        'ramp': 'Ramp',
        'other': 'Other'
    };

    transform(value: string) {
        if (this.types.hasOwnProperty(value)) {
            return this.types[value];
        } else {
            return value;
        }
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/shared/barrier-name.pipe.ts